"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var Play = function Play(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.52081 0.122289C2.84189 -0.0530018 3.23305 -0.0389906 3.54076 0.158822L17.5408 9.15882C17.827 9.34282 18 9.65974 18 10C18 10.3403 17.827 10.6572 17.5408 10.8412L3.54076 19.8412C3.23305 20.039 2.84189 20.053 2.52081 19.8777C2.19974 19.7024 2 19.3658 2 19V1C2 0.634194 2.19974 0.297579 2.52081 0.122289Z"
  })));
};
var _default = exports["default"] = Play;